import { Link } from 'gatsby'
import { useLocaleContext } from '../LocaleContext'
import { isLinkForUnifiedWeb } from '../../utils/isLinkForUnifiedWeb'

const AutoLink = ({ destination, url, target, children, ...rest }) => {
  const { localeLower } = useLocaleContext()
  if (destination) {
    const destinationUrl = `/${localeLower}/${destination.slug}`
    if (isLinkForUnifiedWeb(destinationUrl, localeLower)) {
      return (
        <a href={destinationUrl} {...rest} data-unified-url-slug="true">
          {children}
        </a>
      )
    } else {
      return (
        <Link to={destinationUrl} {...rest} data-dotcom-url-slug="true">
          {children}
        </Link>
      )
    }
  }
  if (url) {
    return (
      <a
        href={url}
        target={target ? '_self' : '_blank'}
        data-default-url-slug="true"
        {...rest}
      >
        {children}
      </a>
    )
  }
}

export default AutoLink
